import Vue from 'vue'
import { Button, Row, Col, Table, TableColumn, RadioButton, RadioGroup } from 'element-ui'

Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(RadioButton)
Vue.use(RadioGroup)
